<div class="contact-us">
  <div class="left-section">
    <div class="heading">How can we help?</div>
    <div class="response-time">We typically respond within 24 hours</div>
    <div class="sub-heading">
      Need quick assistance?
      <a href="mailto:support@evaltrix.com" target="_blank" rel="noopener noreferrer" class="email-link"
        (click)="openEmailClient()">Email us at support@evaltrix.com</a>
      or fill out the form below.
    </div>
    <form [formGroup]="contactForm" (ngSubmit)="submit(formDirective)" #formDirective="ngForm">
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Name</mat-label>
        <input matInput required formControlName="name" placeholder="Your full name" maxlength="100">
        <mat-error *ngIf="contactForm.controls.name.errors">Name is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" placeholder="your@email.com" required maxlength="100">
        <mat-error *ngIf="contactForm.controls.email.invalid">Please enter a valid email</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Message</mat-label>
        <textarea matInput required formControlName="message" placeholder="Tell us how we can help you..." rows="5"
          maxlength="1000"></textarea>
        <mat-hint align="end">{{contactForm.get('message')?.value?.length || 0}}/1000</mat-hint>
        <mat-error *ngIf="contactForm.controls.message.errors">Message is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Additional Details (Optional)</mat-label>
        <textarea matInput formControlName="additionalDetails"
          placeholder="Any additional information that might help us assist you better..." rows="3"
          maxlength="500"></textarea>
        <mat-hint align="end">{{contactForm.get('additionalDetails')?.value?.length || 0}}/500</mat-hint>
      </mat-form-field>
      <button mat-flat-button color="primary" class="btn-submit" type="submit"
        [disabled]="!contactForm.valid || isSubmitting">
        <span *ngIf="!isSubmitting">Send Message</span>
        <span *ngIf="isSubmitting">Sending...</span>
      </button>
    </form>
  </div>
  <div class="right-section">
    <img src="../../../assets/contactus.png" class="contact-icon" alt="Contact Support Illustration">
  </div>
</div>